// Auto generated file, do not manually modify!
// com.hotpads.capps.enums.ApplicationRole

export enum ApplicationRole {
  COAPPLICANT = 'COAPPLICANT',
  GUARANTOR = 'GUARANTOR',
  PRIMARY_APPLICANT = 'PRIMARY_APPLICANT',
}

export const ApplicationRole_values = [
  ApplicationRole.COAPPLICANT,
  ApplicationRole.GUARANTOR,
  ApplicationRole.PRIMARY_APPLICANT,
] as const;
